// Components/LeaveTracker.jsx
import { useState } from 'react';
import '../Assests/Leave_tracker.css';
import LeaveSummary from '../Components/Leave_summery';
import LeaveBalance from '../Components/Leave_balance';
import LeaveRequests from '../Components/Leave_request';
// import Shift from '../Components/shift'; due to deployment failure it has been commented

export default function LeaveTracker() {
  const [activeTab, setActiveTab] = useState('summary');

  const tabs = [
    { id: 'summary', label: 'Leave Summary' },
    { id: 'balance', label: 'Leave Balance' },
    { id: 'requests', label: 'Leave Requests' },
    // { id: 'shift', label: 'Shift' }
  ];

  const renderContent = () => {
    switch (activeTab) {
      case 'summary':
        return <LeaveSummary />;
      case 'balance':
        return <LeaveBalance />;
      case 'requests':
        return <LeaveRequests />;
      default:
        return <LeaveSummary />;
    }
  };

  return (
    <div className="leave-tracker-container">
      {/* Tabs */}
      <div className="tabs-container">
        {tabs.map((tab) => (
          <button
            key={tab.id}
            className={`tab ${activeTab === tab.id ? 'active' : ''}`}
            onClick={() => setActiveTab(tab.id)}
          >
            {tab.label}
          </button>
        ))}
      </div>

      {/* Content Area */}
      <div className="content-area">
        {renderContent()}
      </div>
    </div>
  );
}